import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Rx";
import {HttpClient} from "@angular/common/http";
import {PortfolioList, PortolioCategories, WSResponse} from "./portfolio.datatypes";
import {BehaviorSubject} from "rxjs/BehaviorSubject";

@Injectable()
export class PortfolioService {
    private techList = new BehaviorSubject<string[]>([]);
    public currentList = this.techList.asObservable();
    private items = new BehaviorSubject<PortfolioList[]>([]);
    public portfolioList = this.items.asObservable();
    private categories = new BehaviorSubject<PortolioCategories>(null);
    public portfolioCategories = this.categories.asObservable();
    private _portfolioUrl = 'ws/portfolioInfo.php';
    private errorMsg;
    private configs = new BehaviorSubject<object>({icons: null});
    public config = this.configs.asObservable();


    constructor(private http: HttpClient) {
        this.getPortfolio();
    }

    private getPortfolio() {
        let serverResponse: WSResponse;
        this.loadPortfolio().subscribe(
            (data) => {
                serverResponse = data[0];
                this.configs.next(data[1] as string[]);
            },
            (error) => this.errorMsg = <any>error,
            () => {
                if (serverResponse.success) {
                    this.items.next(serverResponse.message.portfolio);
                    this.categories.next(serverResponse.message.categories);
                } else {
                    console.error(serverResponse.message);
                }
            }
        );
    }

    private loadPortfolio() {
        let dataUrl = this._portfolioUrl + "?cmd=portfolio";
        let configUrl = "assets/config.json";
        return Observable.forkJoin(
            this.http.get<WSResponse>(dataUrl),
            this.http.get(configUrl)
        );
    }


    updateTechlist(list: string[]) {
        this.techList.next(list);
    }

}



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio-service.service.ts